export default "__VITE_ASSET__BMVgpxSp__"